import { useEffect } from 'react';

const SITE_URL = 'https://northwesttitlealliance.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

const SITE_DESCRIPTION =
  'Northwest Title Alliance builds AI-powered tools for title professionals — the AXIOM virtual underwriter family, ART, the AI-rendered title plant, and TrueNorth survey intelligence. Northwest roots, national reach.';

const setByName = (name, content) => {
  const el = document.querySelector(`meta[name="${name}"]`);
  if (el) el.setAttribute('content', content);
};

const setByProperty = (property, content) => {
  const el = document.querySelector(`meta[property="${property}"]`);
  if (el) el.setAttribute('content', content);
};

const usePageMeta = (title, description, ogUrl, ogImage) => {
  const desc = description || SITE_DESCRIPTION;
  const url = ogUrl || `${SITE_URL}/`;
  const image = ogImage || DEFAULT_OG_IMAGE;
  useEffect(() => {
    document.title = title;
    setByName('description', desc);
    setByProperty('og:title', title);
    setByProperty('og:description', desc);
    setByProperty('og:url', url);
    setByProperty('og:image', image);
    setByName('twitter:title', title);
    setByName('twitter:description', desc);
    setByName('twitter:image', image);
  }, [title, desc, url, image]);
};

export default usePageMeta;
